export default {
  en: {
    'password-entry-form.title': 'Please enter the Elster Password to submit this return',
    'password-entry-form.continue': 'Continue',
    'password-entry-form.cancel': 'Cancel',
    'password-entry-form.label': 'Password',
    'password-entry-form.placeholder': 'Enter password',
    'password-entry-form.error': 'Please enter a password.',
  },
};
